import { t } from 'i18next';
import { useFormContext } from 'react-hook-form';

import { GrantsModule } from './types';

import Grid from '@mui/material/Grid';

import {
  ControlledCheckbox,
  ControlledTextField
} from 'components/shared/ControlledFields';
import { GridContainer } from 'components/shared/Grid/Grid.components';

const ModuleDataSection = () => {
  const { control } = useFormContext<GrantsModule>();

  return (
    <GridContainer direction={'column'} mt={2}>
      <Grid>
        <ControlledTextField
          control={control}
          disabled
          name="grantName"
          label={t('grants.modules.grid.grantName')}
        />
      </Grid>
      <Grid>
        <ControlledCheckbox
          control={control}
          name="enabled"
          label={t('grants.modules.grid.enabled')}
        />
      </Grid>
    </GridContainer>
  );
};

export default ModuleDataSection;
